module.exports = __webpack_public_path__ + "img/tankertruck.5a2b6934.svg";